import {makeStyles} from '@material-ui/styles'

export default makeStyles(theme => ({
    root : {
        paddingLeft: '3vw',
        marginLeft: '100px'
    }
}))